import React, { Component } from 'react'

import wines from './sasong_oliv.png'


class Products extends Component{

  render() {
    return(
      <div className="Landing-product-row">
        <div className="Landing-product">
          <span className="Landing-product-select">
          </span>
          <div className="Landing-product-img-div">
            <img
              src={wines}
              alt=""
              className="w-100"
              />
          </div>
          <div className="Landing-product-info">
            <p className="Landing-product-title">Säsongsviner</p>
            <p className="Landing-product-price">1595kr per leverans (2ggr/året)</p>
            <p className="Landing-product-about">
              En låda med 11st av säsongens viner från Escapat och en flaska av
              Escapats egna olivolja. Det kommer vara mer fokus på rött under
              det kalla året och mer vitt och rose på våren och sommaren.
              Levereras i april och november.
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default Products



// WEBPACK FOOTER //
// ./src/containers/landing/Products.jsx